import * as React from 'react';

/**
 * Hook de inicialização de autenticação.
 *
 * A partir da auth-client-lib v2 o fluxo de sessão é totalmente gerenciado pela
 * biblioteca: os HOCs de SSR (`withSSRSession`) redirecionam usuários não
 * autenticados no servidor e os interceptors de HTTP cuidam do refresh/logout
 * do token no cliente. Portanto não há mais necessidade dos endpoints legados
 * (`old-cookies-handler`/`should-sign-in`) nem de disparar sign-in manualmente.
 */
export function useAuthInitialization() {
  const [isInitialized, setIsInitialized] = React.useState(false);

  React.useEffect(() => {
    setIsInitialized(true);
  }, []);

  return { isInitialized };
}
